module.exports = __webpack_public_path__ + "static/img/eicad_card.932abece.png";